import React, { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import s from './RhfDebugHelperStyles.scss'
import clsx from 'clsx'
import { DevTool } from '@hookform/devtools'

export const RhfDebugHelper: React.FC = () => {
  const {
    control,
    errors,
    getValues,
  } = useFormContext()

  const debugToolOpenKey = 'debugToolOpen'
  const [debugToolOpen, setDebugToolOpen] = useState(true)
  const handleToggleDebugToolOpen = () => {
    localStorage.setItem(debugToolOpenKey, `${!debugToolOpen}`)
    setDebugToolOpen(!debugToolOpen)
  }

  const debugToolPositionBesidesDevToolKey = 'debugToolPositionBesidesDevTool'
  const [debugToolPositionBesidesDevTool, setDebugToolPositionBesidesDevTool] = useState(true)
  const handleToggleDebugToolPositionBesidesDevTool = () => {
    localStorage.setItem(debugToolPositionBesidesDevToolKey, `${!debugToolPositionBesidesDevTool}`)
    setDebugToolPositionBesidesDevTool(!debugToolPositionBesidesDevTool)
  }

  useEffect(() => {
    setDebugToolOpen(localStorage.getItem(debugToolOpenKey) === 'true')
    setDebugToolPositionBesidesDevTool(localStorage.getItem(debugToolPositionBesidesDevToolKey) === 'true')
    // eslint-disable-next-line -- only run on mount
  }, [])

  return <>
    <DevTool control={control} />
    <div className={s.iconContainer}>
      <div
        onClick={handleToggleDebugToolOpen}
        className={clsx(
          s.icon,
          debugToolOpen && s.iconClose,
          !debugToolOpen && s.iconOpen,
        )}
      />
    </div>

    <div className={clsx(
      s.debugContainer,
      debugToolOpen && s.debugContainerClosed,
      debugToolOpen && debugToolPositionBesidesDevTool && s.positionBesidesDevTools,
    )}
    >
      <div className={clsx(s.heading)}>
        <span
          className={clsx(s.iconExtend, debugToolPositionBesidesDevTool && s.rotateIcon180)}
          onClick={handleToggleDebugToolPositionBesidesDevTool}
        />&nbsp;Errors:
      </div>
      <pre>
        {JSON.stringify(errors, null, 3)}
      </pre>
      <div className={clsx(s.heading)}>Values:</div>
      <pre>
        {JSON.stringify(getValues(), null, 3)}
      </pre>
    </div>
  </>
}
